import Row from 'components/Row'
import TextBody from 'components/TextBody'
import useDispatch from 'modules/component/utils/hooks/useDispatch'
import useIntl from 'modules/component/utils/hooks/useIntl'
import useSelector from 'modules/component/utils/hooks/useSelector'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import React from 'react'
import { defineMessages } from 'react-intl'
import logEventAnalyticsUtil from 'modules/analytics/utils/log-event'
import { useTheme } from 'modules/styles/index.js'
import loadProfilesWhoStartedThisWorkout from 'modules/workout/redux/actions/load-profiles-who-started/index.js'
import { logUtil } from 'packages/src'
import ProfileImages from 'components/ProfileImages/index.js'
import { getIdReduxUtil } from '@gymaholic/packages'
import ProfileImageMedia from 'components/ProfileImageMedia/index.js'
import getProfilesWhoStartedWorkoutSelect from 'modules/workout/redux/selectors/get-profiles-who-started/index.js'
import getStartedCountWorkoutSelect from 'modules/workout/redux/selectors/get-started-count/index.js'
import isRecommendedWorkoutSelect from '@gymaholic/packages/src/modules/workout/redux/selectors/is-recommended/index.js'

const messages = defineMessages({
  startedCount: {
    id: 'ProfilesWhoStartedThisWorkout.startedCount',
    defaultMessage: '{startedCount} {startedCount, plural, one {person} other {people}} started this workout'
  }
})

const ANALYTICS_EVENT = {
  SHOW_PROFILES_WHO_STARTED_THIS_WORKOUT: 'SHOW_PROFILES_WHO_STARTED_THIS_WORKOUT'
}

export function ProfilesWhoStartedThisWorkout (props) {
  const {
    isPending,
    mx
  } = props
  const dispatch = useDispatch()
  const startedCount = useSelector(getStartedCountWorkoutSelect)
  const intl = useIntl()
  const theme = useTheme()
  const profilesWhoStarted = useSelector(getProfilesWhoStartedWorkoutSelect)
  const hasLoadedRef = React.useRef()
  const profilesWhoStartedCount = profilesWhoStarted.length
  const isVisible = !!profilesWhoStartedCount
  const isRecommended = useSelector(isRecommendedWorkoutSelect)

  const load = async () => {
    dispatch(loadProfilesWhoStartedThisWorkout())
    hasLoadedRef.current = true
  }

  React.useEffect(() => {
    if (
      isRecommended &&
      startedCount &&
      !profilesWhoStartedCount &&
      !isPending &&
      !hasLoadedRef.current
    ) {
      load()
    }
  }, [
    isRecommended,
    startedCount,
    isPending,
    profilesWhoStartedCount
  ])

  const debugProps = {
    startedCount,
    profilesWhoStarted,
    isPending,
    isVisible,
    hasLoadedRef,
    profilesWhoStartedCount,
    isRecommended
  }

  logUtil('ProfilesWhoStartedThisWorkout').debug('debugProps=', debugProps)

  React.useEffect(() => {
    if (isVisible) {
      logEventAnalyticsUtil(ANALYTICS_EVENT.SHOW_PROFILES_WHO_STARTED_THIS_WORKOUT)
    }
  }, [isVisible])

  if (!isVisible) {
    return <></>
  }

  return (
    <Row
      mx={mx}
      mb={2}
      mt
      ac
    >
      <ProfileImages>
        {
          profilesWhoStarted.map((profile) => {
            const profileId = getIdReduxUtil(profile)
            return (
              <ProfileImageMedia
                key={profileId}
                id={profileId}
                size={theme.sizes.icons.NORMAL}
              />
            )
          })
        }
      </ProfileImages>

      <TextBody>
        {
          formatMessageIntlUtil(
            intl,
            messages.startedCount,
            { startedCount }
          )
        }
      </TextBody>
    </Row>
  )
}
